import { useCustomMediaQuery } from '@libs/hooks/useCustomMediaQuery';

export type subheaderDevice = 'subheaderDesktop' | 'subheaderTablet' | 'subheaderMobile';

export const SUBHEADER_MEDIA_QUERIES: Record<subheaderDevice, string> = {
  subheaderDesktop: '(min-width: 1200px)',
  subheaderTablet: '(max-width: 1199px) and (min-width: 820px)',
  subheaderMobile: '(max-width: 819px)',
};

export function useSubheaderMediaQuery() {
  const device: subheaderDevice = useCustomMediaQuery(SUBHEADER_MEDIA_QUERIES, 'subheaderDesktop');

  return {
    device,
  };
}
